type FirebaseRemoteConfig = Record<string, string | number | boolean> & {
  signUpByEmail: boolean;
};

export const defaultFirebaseRemoteConfig: FirebaseRemoteConfig = {
  signUpByEmail: false,
};
